import { render, staticRenderFns } from "./deliveryCompany.vue?vue&type=template&id=7a61d3cb&"
import script from "./deliveryCompany.vue?vue&type=script&lang=js&"
export * from "./deliveryCompany.vue?vue&type=script&lang=js&"
import style0 from "./deliveryCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports